export default __webpack_public_path__ + "static/media/money-bill-wave-solid.b54fc313.svg";